import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSuperbillAnalyses = asyncThunkWrapper({ 
  model: 'superbillAnalyses', 
  action: 'getSuperbillAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at']
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/superbill_flow/superbill_analyses', { params });

    return response.data;
  } 
});
export const getSuperbillAnalysis = asyncThunkWrapper({ 
  model: 'superbillAnalyses', 
  action: 'getSuperbillAnalysis', 
  func: async ({ id, cable = false }) => {
    const params = { attributes: ['id', 'result', 'status', 'updated_at'] };
    const response = await axios.get(`/superbill_analyses/${id}`, { params });
      
    return { data: response.data, cable };
  } 
});
export const clearLocalSuperbillAnalyses = createAction('superbillAnalyses/clearLocalSuperbillAnalyses');
export const clearLocalActiveSuperbillAnalysis = createAction('superbillAnalyses/clearLocalActiveSuperbillAnalysis');